import { QueryClient } from '@eigtech/ui-shared-api'
import { defaultQueryClientConfig } from '@eigtech/ui-shared-api-web'

export const queryClient = new QueryClient(defaultQueryClientConfig())
